import React from "react";
import { useConfirmationModalContext } from "./modalConfirmationContext";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxArchive } from "@fortawesome/free-solid-svg-icons";

type Props = {
    onClick: (event: any) => void;
    title?: string;
    hidden?: boolean;
    description?: string;
    iconButton?: any;
    variant?: string;
};

const ArchiveButton = (props: Props) => {
    const modalContext = useConfirmationModalContext();

    const handleOnCLick = async (
        event: React.MouseEvent<HTMLButtonElement>
    ) => {
        const result = await modalContext.showConfirmation(
            "Confirmación",
            <div>
                <p>{props.description ?? ""}</p>
            </div>
        );
        result && props.onClick && props.onClick(event);
    };

    return (
        <Button
            title={props.title ?? "Archivar"}
            variant={props.variant ?? "secondary"}
            size="sm"
            active
            onClick={handleOnCLick}
            hidden={props.hidden !== undefined ? props.hidden : false}
        >
            <FontAwesomeIcon
                icon={props.iconButton ? props.iconButton : faBoxArchive}
                className="white"
            />
        </Button>
    );
};

export default ArchiveButton;
